import React, { useEffect, useRef, useState } from "react";
import { closingAgentTitle } from "../offer/cif/formFields";
import { BsCheckCircleFill } from "react-icons/bs";
import DynamicForm from "../offer/cif/DynamicForm";
import ContinueConfirmationModal from "./ContinueConfirmationModal";
import ReactHtmlParser from "react-html-parser";
import { validateAddress } from "@/api/bid";
import { spbpDescText } from "@/data/sellerPaysBuyersPays";

const EditClosingAgent = ({
  state,
  setAccordionState,
  accordionState,
  editCifData,
  setEditCifData,
}) => {
  const [closingAgentDetails, setClosingAgentDetails] = useState({});
  const [titleDetails, setTitleDetails] = useState({});
  const [haveErrors, setHaveErrors] = useState(false);
  const [show, setShow] = useState(false);
  const validationFnRef = useRef({
    closingAgent: null,
    titleDetails: null,
  });
  const [error, setError] = useState({});
  const [closingAgentOptions, setClosingAgentOptions] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [optionSelected, setOptionSelected] = useState("");
  const [externalFormErrors, setExternalFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getLabelData();
    if(state?.closingInfoChoice=="BuyerChosen"){
      setOptionSelected("BUYER")
      setShowForm(true)
    }else if(state?.closingInfoChoice=="SellerChosen"){
      setOptionSelected("SELLER")
      setShowForm(false)
    }
    setClosingAgentDetails({
      firstName: state?.closingAgent?.firstName || "",
      email: state?.closingAgent?.email || "",
      phone: state?.closingAgent?.phone || "",
      address1: state?.closingAgent?.address1 || "",
      address2: state?.closingAgent?.address2 || "",
      city: state?.closingAgent?.city || "",
      stateId: state?.closingAgent?.stateId || "",
      zip: state?.closingAgent?.zip || "",
      company:state?.closingAgent?.company || ""
    });
    setTitleDetails({
      firstName: state?.titleProvider?.firstName || "",
      email: state?.titleProvider?.email || "",
      phone: state?.titleProvider?.phone || "",
      address1: state?.titleProvider?.address1 || "",
      address2: state?.titleProvider?.address2 || "",
      city: state?.titleProvider?.city || "",
      stateId: state?.titleProvider?.stateId || "",
      zip: state?.titleProvider?.zip || "",
      company:state?.titleProvider?.company || ""
    });
  }, [state]);
  const checkStateCityZip = async (address1, city, stateId, zip) => {
    try {
      const payload = {
        address1: address1,
        city: city,
        state: stateId,
        zip: zip,
      };
      const data = await validateAddress(payload);
      if (data?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
        // setInvalidCombination(true);
        setExternalFormErrors((prev) => ({
          ...prev,
          zip: "Provided zip code is not valid for selected state",
        }));
        setHaveErrors(true);
        setLoading(false);
        return { hasError: true };
      } else {
        setExternalFormErrors((prev) => {
          const { zip, ...rest } = prev;
          return rest;
        });
        setLoading(false);
        return { hasError: false };
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const submitData = async () => {
    const closingValidation = validationFnRef.current.closingAgent?.();
    const titleValidation = validationFnRef.current.titleDetails?.();

    const allErrors = {
      ...closingValidation?.errors,
      ...titleValidation?.errors,
    };

    const allValid =
      (closingValidation?.isValid ?? true) &&
      (titleValidation?.isValid ?? true); // FIXED THIS LINE

    if (!allValid && showForm) {
      return;
    } else {
      setLoading(true);
      if (state?.closingInfoChoice === "SellerChosen" || !showForm) {
        continueToNext();
        setShow(false);
        setLoading(false);
      } else {
        const cloasingAdd = await checkStateCityZip(
          closingAgentDetails?.address1,
          closingAgentDetails?.city,
          closingAgentDetails?.stateId,
          closingAgentDetails?.zip
        );
        if (cloasingAdd?.hasError) {
          return;
        }
        const titleAdd = await checkStateCityZip(
          titleDetails?.address1,
          titleDetails?.city,
          titleDetails?.stateId,
          titleDetails?.zip
        );
        if (titleAdd?.hasError) {
          return;
        }

        setShow(true);
      }
    }
  };
  const continueToNext = () => {
    setError({});
     const defaultData = {
      firstName:  "",
      email:  "",
      phone:  "",
      address1:  "",
      address2: "",
      city: "",
      stateId:"",
      zip: "",
      company: ""
     }
    setEditCifData({
      ...editCifData,
      closingAgent: showForm?closingAgentDetails:defaultData,
      titleProvider:showForm? titleDetails:defaultData,
      closingInfoChoice: optionSelected==="SELLER"?"SellerChosen":"BuyerChosen",
    });
    handleClose();
    const findNextAccordion = () => {
      setAccordionState({
        ...accordionState,
        accordion3: {
          ...accordionState.accordion3,
          close: true,
          edit: true,
          visited: true,
        },
        accordion4: {
          ...accordionState.accordion4,
          close: false,
          edit: false,
        },
      });
    };
    findNextAccordion();
  };
  const handleClose = () => setShow(false);

  const getLabelData = () => {
    const type = state?.propertyCategoryName;
    let targetObject = spbpDescText.find((item) => item[state?.sellerId]);
    if(!targetObject){
          console.warn(`Seller ID "${state?.sellerId}" not found in spbpDescText. Falling back to DEFAULT.`);
          targetObject = spbpDescText.find(item => item["DEFAULT"]);
        setClosingAgentDetails(targetObject?.["DEFAULT"]?.[type]?.[state?.closingPaymentType])
    }else{
      setClosingAgentOptions(
        targetObject?.[state?.sellerId]?.[type]?.[state?.closingPaymentType]
      );
    }

    
  };  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOptionSelected(value);
    if (name === "sellerBuyerPays" && value === "BUYER") {
      setShowForm(true);
    } else {
      setShowForm(false);
    }
  };

  return (
    <div className="accordion-item mb-2 border rounded">
      <h2 className="accordion-header p-1" id="flush-headingThree">
        <div
          className={`accordion-button ${
            accordionState?.accordion3?.close ? "collapsed" : ""
          }  ${
            accordionState?.accordion3?.close &&
            accordionState?.accordion3?.visited
              ? "no-caret"
              : ""
          }`}
          id="acc2"
          disabled={accordionState?.accordion3?.close}
        >
          <div className="d-flex justify-content-between w-100">
            <p className="mb-0">
              {accordionState?.accordion3?.visited ? (
                <BsCheckCircleFill className="icon_bid me-2" size={30} />
              ) : (
                <BsCheckCircleFill className="text-dark me-2" size={30} />
              )}
              Closing Agent and Title Company Information
            </p>
            {accordionState?.accordion3?.edit && (
              <>
                <div>
                  <span
                    className="fa fa-pencil cursor-pointer"
                    onClick={() => {
                      setAccordionState({
                        ...accordionState,
                        accordion1: {
                          ...accordionState.accordion1,
                          close: true,
                          visited: true,
                          edit: true,
                        },
                        accordion2: {
                          ...accordionState.accordion2,
                          close: true,
                          visited: true,
                          edit: true,
                        },
                        accordion3: {
                          ...accordionState.accordion3,
                          close: false,
                          visited: false,
                          edit: false,
                        },
                      });
                    }}
                  ></span>
                </div>
              </>
            )}
          </div>
        </div>
      </h2>
      {accordionState?.accordion3?.edit ? (
        <>
          <div className="container pb-2">
            <div className="row">
              <p className="mb-0 pt-1 purchase-for-ui">
                Title insurance and property search fees will be covered by :{" "}
                {/* {state?.closingInfoChoice === "SellerChosen" ? (
                  "Seller"
                ) : (
                  <>{optionSelected === "SELLER" ? "Seller" : "Buyer Pays"}</>
                )} */}
 <>{optionSelected === "SELLER" ? "Seller" : "Buyer Pays"}</>
              </p>
              {state?.closingInfoChoice !== "SellerChosen" && showForm && (
                <>
                  <div className="col-6">
                    <p className="edit-buyer-data">Closing Agent :-</p>
                    <>
                      <p className="edit-buyer-data mb-0">
                        {closingAgentDetails?.firstName}
                      </p>
                      <p className="edit-buyer-data">
                        {closingAgentDetails?.email}
                      </p>
                    </>
                  </div>
                  <div className="col-6">
                    <p className="edit-buyer-data">Title Provider :-</p>
                    <>
                      <p className="edit-buyer-data mb-0">
                        {titleDetails?.firstName}
                      </p>
                      <p className="edit-buyer-data">{titleDetails?.email}</p>
                    </>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <div
          id="flush-collapseThree"
          className={`accordion-collapse collapse ${
            accordionState?.accordion3?.close ? "" : "show"
          }`}
          aria-labelledby="flush-headingThree"
          data-bs-parent="#accordionFlushExample"
        >
          <div className="accordion-body">
            <p className="mb-0 pt-1 purchase-for-ui">
              Title insurance and property search fees will be covered by :
            </p>

          {[...state?.closingOptionDetails || []]
  .sort((a, b) => {
    if (a.closingOption === 'SELLER_PAYS') return -1;
    if (b.closingOption === 'SELLER_PAYS') return 1;
    return 0;
  })
  .map((data, index) => (
    <React.Fragment key={index}>
      {state?.closingOptionDetails?.length === 1 ? (
        <p>
          <span className="closingAgent-label ml10">
            {data?.closingOptionLabel} :{" "}
          </span>
          <span className="ml10 closingAgent-val">
            {data?.closingOptionLabel === "Buyer Pays"
              ? ReactHtmlParser(
                  `Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.`
                )
              : ""}
          </span>
        </p>
      ) : (
        <div className="align-items-center py-3">
          <input
            type="radio"
            name="sellerBuyerPays"
            value={data?.closingOption === "SELLER_PAYS" ? "SELLER" : "BUYER"}
            id={data?.closingOption}
            onChange={(e) => handleChange(e)}
            className="form-check-input"
            checked={
              optionSelected ===
              (data?.closingOption === "SELLER_PAYS" ? "SELLER" : "BUYER")
            }
          />
          <label
            className="closingAgent-label ml10"
            htmlFor={data?.closingOption}
          >
            <strong>
              {closingAgentOptions?.[data?.closingOption]?.label} :
            </strong>
          </label>
          <span className="ml10 closingAgent-val">
            {ReactHtmlParser(
              closingAgentOptions?.[data?.closingOption]?.text
                ?.replace(/##STATEID##/g, data?.stateName)
                ?.replace(/##AMOUNT##/g, data?.formatAmount)
            )}
          </span>
        </div>
      )}
    </React.Fragment>
  ))}

            {/* state?.closingInfoChoice !== "SellerChosen" &&  */}
            {(showForm) && (
              <>
                <div className="buyer-form row">
                  <div className="col-6">
                    <h6>Closing Agent</h6>
                    <DynamicForm
                      fieldsConfig={closingAgentTitle}
                      setCifFormDetails={setClosingAgentDetails}
                      cifFormetails={closingAgentDetails}
                      // preFilledEmail={
                      //   state?.buyerAgent?.email ? true : false
                      // }
                      col={"col-12"}
                      setHaveErrors={setHaveErrors}
                      //   validateAgentEmail={validateEmail}
                      //   statePrefilled={"state"}
                      registerValidationTrigger={(fn) =>
                        (validationFnRef.current.closingAgent = fn)
                      }
                      externalErrors={externalFormErrors}
                    />
                  </div>
                  <div className="col-6">
                    <h6>Title Provider</h6>
                    <DynamicForm
                      col={"col-12"}
                      fieldsConfig={closingAgentTitle}
                      setCifFormDetails={setTitleDetails}
                      cifFormetails={titleDetails}
                      // preFilledEmail={
                      //   state?.buyerAgent?.email ? true : false
                      // }
                      setHaveErrors={setHaveErrors}
                      //   validateAgentEmail={validateEmail}
                      //   statePrefilled={"state"}
                      registerValidationTrigger={(fn) =>
                        (validationFnRef.current.titleDetails = fn)
                      }
                      externalErrors={externalFormErrors}
                    />
                  </div>
                </div>
                {error?.corporateLicenseState?.length > 0 && (
                  <p className={`error-message-offer `}>
                    {error?.corporateLicenseState}
                  </p>
                )}
              </>
            )}

            <button
              type="submit"
              className="continue-button ml10"
              onClick={submitData}
            >
              Continue
            </button>
          </div>
        </div>
      )}

      <ContinueConfirmationModal
        continueToAgent={continueToNext}
        handleClose={handleClose}
        show={show}
        type={"closing"}
      />
    </div>
  );
};

export default EditClosingAgent;
